export default __webpack_public_path__ + "static/media/content.bfda1132.csv";